function MarketplaceFilled({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 5.5V0H7V5.5L10 8.5L13 5.5ZM5.5 7H0V13H5.5L8.5 10L5.5 7ZM7 14.5V20H13V14.5L10 11.5L7 14.5ZM14.5 7L11.5 10L14.5 13H20V7H14.5Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default MarketplaceFilled;
